<script>
export default {
  name: "Logout",
  data() {
    return {};
  },
  mounted() {
    this.sair();
  },
  methods: {
    sair() {
      window.sessionStorage.setItem("permissoes", "");
      window.sessionStorage.setItem("cartao", "");
      window.sessionStorage.setItem("cpf", "");
      window.sessionStorage.setItem("nome", "");
      //window.sessionStorage.setItem(btoa("user"), "");
      window.sessionStorage.setItem("token", "");
      window.sessionStorage.setItem("menu", "false");
      // document.getElementById('id_menu').style.visibility = false;
      //this.$store.dispatch('addMenu', false)
      //window.sessionStorage.setItem("menu",false)

      this.$router.push("/login");
    }
  }
};
</script>
<template>
  
</template>

</template>



// WEBPACK FOOTER //
// src/components/Logout.vue